import { Component, EventEmitter, Input, Output } from '@angular/core';

type SisToastTone = 'info' | 'success' | 'warning' | 'error';

@Component({
  selector: 'app-sis-toast',
  templateUrl: './sis-toast.component.html',
  styleUrls: ['./sis-toast.component.css'],
  standalone: false
})
export class SisToastComponent {
  @Input() show = false;
  @Input() tone: SisToastTone = 'info';
  @Input() message = '';

  @Output() close = new EventEmitter<void>();
}
